'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { AuthWrapper } from '../AuthWrapper';
import { AuthBackground } from '../ui/AuthBackground';
export const AuthLayout = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AuthBackground className="absolute left-0 top-0  h-screen w-screen" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className="flex h-screen w-screen items-center justify-center">{t1}<div className="z-1 absolute left-0 top-0 h-screen w-screen"><div className="h-full w-full"><AuthWrapper>{children}</AuthWrapper></div></div></div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};